import React, { useState, useEffect } from 'react'
import injectStyles from 'react-jss'

import SearchBox from '../../FilterAndPaginationComponent/SearchBox'
import { debounce } from '../../../Utils/Functions'
import { searchPostcodesPFGQL } from '../../../Module/graphQL/PathFinder/pathFinderGQL'
import { normalizeGraphQLConnection } from '../../../shared/graphql/utils'
import styles from '../styles'

/**
 * Wrapper around searchPostcodesPFGQL that handles errors and basic formatting
 * @param {object} variables GQL query variables
 * @returns {array} Postcodes
 */
const searchPostcodesPFGQLWrapper = async variables => {
  const response = await searchPostcodesPFGQL(variables)
  const { data, errors } = await response.json()
  if (errors && errors.length) {
    throw data.errors[0].message
  }
  return normalizeGraphQLConnection(data.searchPostcodes).map(
    ({ name }) => name,
  )
}

/**
 * Component with the autosuggestive search for postcodes and multi-select for choosing them
 * @param {string} props.countryCode Country code
 * @param {function} props.onUpdate To notify parent about any new active tags ot if any were deleted
 * @param {object} props.classes styles
 *
 * @returns {JSX.Element} <PostcodesSearch />
 */
const PostcodesSearch = ({ countryCode, onUpdate, classes }) => {
  const [activeTags, setActiveTags] = useState([])
  const [suggestions, setSuggestions] = useState([])

  /**
   * Will call onUpdate if activeTags were changed
   */
  useEffect(() => {
    onUpdate({ activeTags, suggestions })
  }, [activeTags])

  /**
   * Sends request to the PF with searchedString and sets result as suggestions
   * Debounce 1s to prevent spam
   * @param {object} searchString Searched postcode name
   */
  const onSearch = debounce(async searchString => {
    const suggestions = await searchPostcodesPFGQLWrapper({
      searchString,
      countryCode,
    })
    setSuggestions(suggestions)
  }, 1000)

  /**
   * Add tag
   */
  const onAddTag = tag => setActiveTags([...activeTags, tag])

  /**
   * Delete selected tag
   */
  const onRemoveTag = tag =>
    setActiveTags(activeTags => activeTags.filter(item => item !== tag))

  return (
    <div className={classes.wrapper}>
      <SearchBox
        className={classes.searchBox}
        onChange={onSearch}
        handleInputChange={onSearch}
        suggestions={suggestions}
        tags={activeTags}
        onAddTag={onAddTag}
        onRemoveTag={onRemoveTag}
        placeholder={'Search for postcodes'}
      />
    </div>
  )
}

export default injectStyles(styles)(PostcodesSearch)



// WEBPACK FOOTER //
// ./src/Components/PostcodesSearch/component/PostcodesSearch.jsx